import { Outlet } from 'react-router-dom';
import { useState, useEffect } from 'react';
import MobileNativeShell from '../layout/MobileNativeShell';
import { getSectionByKey } from '../../services/siteSections';
import AssistantWidget from '../assistant/AssistantWidget';
import { FakeBookingsSantaRosa } from '../FakeBookingsSantaRosa';
import RuletaPremiosWrapper from '../public/RuletaPremiosWrapper';
import PublicBottomNav from './PublicBottomNav';

export default function PublicMobileNativeLayout() {
  const [logoUrl, setLogoUrl] = useState<string>('');

  useEffect(() => {
    loadLogo();
  }, []);

  const loadLogo = async () => {
    try {
      const heroSection = await getSectionByKey('hero');
      if (heroSection?.content_json?.logo) {
        setLogoUrl(heroSection.content_json.logo);
      }
    } catch (error) {
      console.error('Error loading logo:', error);
    }
  };

  return (
    <MobileNativeShell
      headerCenter={
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 flex items-center justify-center">
            {logoUrl ? (
              <img
                src={logoUrl}
                alt="Fotos y Video Santa Rosa"
                className="w-full h-full object-contain"
              />
            ) : (
              <i className="ri-camera-lens-fill text-xl text-pink-600"></i>
            )}
          </div>
          <span className="text-sm font-semibold text-gray-900">Santa Rosa</span>
        </div>
      }
      showHeader={true}
      showBottomNav={true}
      bottomNav={<PublicBottomNav />}
      safeAreaTop={true}
      safeAreaBottom={true}
    >
      <Outlet />
      <FakeBookingsSantaRosa />
      <RuletaPremiosWrapper />
    </MobileNativeShell>
  );
}